module.exports = __webpack_public_path__ + "img/github.4eb836ff.png";